import { Skeleton, Stack } from "@mui/material";
import { RewardsListHeader } from "Components/Loyalty/Shared/Rewards/RewardsList/RewardsListHeader";
import { SectionTitle } from "Components/Loyalty/Shared/SectionTitle/SectionTitle";

type Props = {
  title: string;
  pointsLabel: string;
  skeletonCount?: number;
};

export const RewardsSkeleton = ({
  title,
  pointsLabel,
  skeletonCount = 10,
}: Props) => (
  <Stack gap={4}>
    <SectionTitle>{title}</SectionTitle>
    <Stack gap={4}>
      <RewardsListHeader pointsLabel={pointsLabel} />
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <Skeleton
          // biome-ignore lint/suspicious/noArrayIndexKey: fine here
          key={index}
          variant="rectangular"
          height={20}
          sx={{ borderRadius: 1.25 }}
        />
      ))}
    </Stack>
  </Stack>
);
